if (!customElements.get('m-sharing')) {
  class MSharing extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        shareContent: ".m-product-addon--sharing",
        openBtn: "[data-open-share]"
      };
    }

    connectedCallback() {
      this.domNodes = queryDomNodes(this.selectors, this);
      const { shareContent: e } = this.domNodes;
      if (e && e.innerHTML) {
        this.shareContent = e.innerHTML;
        this.init();
      }
    }

    init() {
      if (this.domNodes.openBtn) {
        this.domNodes.openBtn.classList.remove("m:hidden");
      }
      this.modal = new MinimogTheme.Modal();
      addEventDelegate({
        selector: this.selectors.openBtn,
        handler: e => {
          e.preventDefault();
          if (this.shareContent) {
            const el = document.createElement("DIV");
            el.classList.add("m-sharing__content");
            el.innerHTML = this.shareContent;
            this.modal.appendChild(el);
            this.modal.setSizes("m-sharing");
            this.modal.open();
          }
        }
      });
    }
  }

  customElements.define("m-sharing", MSharing);
}
